// extracted by mini-css-extract-plugin
export default {"label":"SelectType_label__l8+-m","select":"SelectType_select__xsgGu","selectError":"SelectType_selectError__My9VT"};